import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getProductCategory = createAsyncThunk(
  "getProductCategory",
  async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/product-category`
      );
      ;
      return data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getProductClassification = createAsyncThunk(
  "getProductClassification",
  async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/product-classification`
      );
      ;
      return data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const ProductSlice = createSlice({
  name: "Products",
  initialState: {
    productClassification: [],
    productCategory: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: {
    [getProductCategory.pending]: (state) => {
      state.status = "pending";
    },
    [getProductCategory.fulfilled]: (state, action) => {
      state.status = "success";
      state.error = action.error;
      state.productCategory = action.payload;
    },
    [getProductCategory.rejected]: (state, action) => {
      state.status = "failed";
      state.productCategory = null;
      state.error = action.error;
    },
    [getProductClassification.pending]: (state) => {
      state.status = "pending";
      state.productClassification = []
    },
    [getProductClassification.fulfilled]: (state, action) => {
      state.status = "success";
      state.error = action.error;
      state.productClassification = action.payload;
    },
    [getProductClassification.rejected]: (state, action) => {
      state.status = "failed";
      state.productClassification = null;
      state.error = action.error;
    },
  },
});

export default ProductSlice.reducer;
